import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  mapMutations,
} from 'vuex';

export default {
  name: 'CustomInputRegion',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    name: '',
    label: '',
    property: '',
    modelState: '',
    rules: '',
    disabled: false,
    placeholder: '',
    mask: '',
  },
  data: () => ({
    changed: false,
  }),
  computed: {
    model: {
      get() {
        return this.modelState;
      },
      set(newModel) {
        if (newModel != null) {
          const changePersonalDataStateObject = {
            state: newModel,
            property: this.property,
          };

          this.setRegionDataMutation(changePersonalDataStateObject);
        }

        return newModel;
      },
    },
    showMask() {
      return this.changed && (typeof this.mask !== 'undefined');
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setRegionDataMutation: 'SET_REGIONDATA',
    }),
    triggerChange() {
      this.changed = true;
    },
  },
};
